import { createFileRoute } from '@tanstack/react-router';
import { checkCountryIdBeforeLoad, instagramHashtagAnalyticsStaticData } from '../instagram';

export const Route = createFileRoute('/_private-routes/hashtag-analytics/instagram/')({
  staticData: instagramHashtagAnalyticsStaticData,
  beforeLoad: checkCountryIdBeforeLoad('/hashtag-analytics/instagram/$countryId')
});
